import { useState } from "react";
import { Controller, useForm } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";
import { Form, Input, Button, App } from "antd";

import { forgotPassword } from "../api/forgotPasswordAPI";
import { styles } from "../styles/forgotPasswordStyles";
import {
  IForgotPassword,
  ForgotPasswordSchema,
} from "../type/forgotPasswordType";

export default function ForgotPasswordForm() {
  const { message } = App.useApp();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<IForgotPassword>({
    resolver: zodResolver(ForgotPasswordSchema),
    defaultValues: {
      email: undefined,
    },
  });

  const onSubmit = async (data: IForgotPassword) => {
    setIsSubmitting(true);
    try {
      await forgotPassword(data);
      message.success("Email sent successfully");
    } catch (error: any) {
      message.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Form
      name="forgetPasswordForm"
      initialValues={{ rememberMe: false }}
      onFinish={handleSubmit(onSubmit)}
      labelAlign="left"
      colon={false}
      layout="vertical"
    >
      <Form.Item
        name="email"
        hasFeedback
        validateStatus={errors.email ? "error" : ""}
        help={errors.email?.message}
      >
        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <Input placeholder="Email" {...field} size="large" />
          )}
        />
      </Form.Item>

      <Form.Item>
        <Button
          style={styles.forgotPasswordButton}
          type="primary"
          htmlType="submit"
          size="large"
          loading={isSubmitting}
        >
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
}
